import { useState, useEffect } from 'react';

import { observeAnchor } from '@web/common/utils/observeAnchor';

export const useLoadMoreButton = (fetchNextPage: VoidFunction) => {
  const [loadMoreNode, setLoadMoreNode] = useState<HTMLDivElement | null>(null);
  useEffect(
    () => observeAnchor(loadMoreNode, (isIntersecting) => isIntersecting && fetchNextPage()),
    [fetchNextPage, loadMoreNode]
  );

  return { setLoadMoreNode };
};
